import { createContext, useState } from "react";

export interface SaveTemplateContextProps {
  saveTemplate: string;
  setSaveTemplate: (option: string) => void;
}

export const SaveTemplateContext = createContext<SaveTemplateContextProps>({
  saveTemplate: "",
  setSaveTemplate: () => { },
});

export function SaveTemplateContextProvider(props: {
  children: React.ReactNode;
}) {
  const [saveTemplate, setSaveTemplate] = useState<string>("");

  return (
    <SaveTemplateContext.Provider value={{ saveTemplate, setSaveTemplate }}>
      {props.children}
    </SaveTemplateContext.Provider>
  );
}
